import { defineComponent as _defineComponent } from 'vue'
import { Icon as PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';
import { useI18n } from '@/composables/use-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompareLoadingContent',
  setup(__props) {

const { t } = useI18n();


return { __sfc: true,t, PtIcon }
}

})